// extracted by mini-css-extract-plugin
export default {"header":"jT0ikk643Cqw1sbbVpKpfQ==","headline":"_67V-P2kAV5L09BRRxC0VDA==","list":"xqde4NnUYHVwDWEx5y538A==","pagination":"a3cKFnnBFNVsMoKuOr8ZMA=="};